import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import ReactRouter from './components/Routes'

ReactDOM.render(
  <React.StrictMode>
    <ReactRouter />
  </React.StrictMode>,
  document.getElementById('root')
)
